module.exports = __webpack_public_path__ + "static/media/1.e1f6b2bd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/images/16009/1.jpg
// module id = 502
// module chunks = 0